import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { companiesService, Company, UpdateCompanyRequest } from '@aslanpay/portal-common-lib';

const useUpdateCompany = ({
  onSuccess,
  onError,
}: UseMutationOptions<Company, Error, UpdateCompanyRequest>) => {
  return useMutation<Company, Error, UpdateCompanyRequest>(
    ({
      id,
      name,
      displayName,
      countryCode,
      companyNumber,
      address,
      vatNumber,
      invoiceEmail,
      invoiceRecipientName,
    }: UpdateCompanyRequest) =>
      companiesService.updateCompany({
        id,
        name,
        displayName,
        countryCode,
        companyNumber,
        address,
        vatNumber,
        invoiceEmail,
        invoiceRecipientName,
      }),
    { onSuccess, onError }
  );
};

export default useUpdateCompany;
